var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.737,
    height: 133.081,
    viewBox: "0 0 113.737 133.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(-318.263 -255.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(260.263 256.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M73.932,117.612H66.191a4.146,4.146,0,0,1-4.141-4.141V7.691A4.146,4.146,0,0,1,66.191,3.55h30.75a1.775,1.775,0,0,0,0-3.55H66.191A7.7,7.7,0,0,0,58.5,7.691v105.78a7.7,7.7,0,0,0,7.691,7.691h7.742a1.775,1.775,0,0,0,0-3.55Z",
    transform: "translate(0 0)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M222.228,25.013,197.736.52a1.8,1.8,0,0,0-.909-.486A2.736,2.736,0,0,0,196.481,0H176a1.775,1.775,0,0,0,0,3.55h18.709v16.8a7.7,7.7,0,0,0,7.691,7.691h16.8v85.428a4.146,4.146,0,0,1-4.141,4.141H152.989a1.775,1.775,0,1,0,0,3.55h62.068a7.7,7.7,0,0,0,7.691-7.691v-87.2A1.8,1.8,0,0,0,222.228,25.013Zm-19.831-.52a4.146,4.146,0,0,1-4.141-4.141V6.059l18.433,18.433Z",
    transform: "translate(-70.774)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M181.8,164.781H120.275a1.775,1.775,0,1,0,0,3.55H181.8a1.775,1.775,0,0,0,0-3.55Z",
    transform: "translate(-45.801 -125.787)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M181.8,231.448H120.275a1.775,1.775,0,1,0,0,3.55H181.8a1.775,1.775,0,0,0,0-3.55Z",
    transform: "translate(-45.801 -176.677)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M181.8,298.115H120.275a1.775,1.775,0,1,0,0,3.55H181.8a1.775,1.775,0,0,0,0-3.55Z",
    transform: "translate(-45.801 -227.568)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M181.8,364.781H120.275a1.775,1.775,0,1,0,0,3.55H181.8a1.775,1.775,0,0,0,0-3.55Z",
    transform: "translate(-45.801 -278.458)",
    fill: "#228caa",
    stroke: "#228caa",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(367 324)",
    fill: "#fff",
    stroke: "#228caa",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plus-positive-add-mathematical-symbol",
    transform: "translate(384.91 341.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M31.191,14.6l-12.9.039V1.989a1.989,1.989,0,0,0-3.979,0L14.347,14.6H1.989a1.989,1.989,0,1,0,0,3.979H14.328V31.191a1.989,1.989,0,0,0,3.979,0V18.58H31.191a1.99,1.99,0,0,0,0-3.979Z",
    fill: "#22aa43",
    stroke: "#3eaa22",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.a8c11baf43c4cd20c2719cfd95a5cbab.svg";
export { ForwardRef as ReactComponent };